var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.show,
        width: "700px",
        "before-close": _vm.closeDialog,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
      },
    },
    [
      _vm.titles[0].num
        ? _c(
            "title-block",
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[0].label)),
              ]),
              _c(
                "div",
                { staticClass: "table mt-10" },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("法定代表人"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.legalPersonName || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("经营状态"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.regStatus || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("注册资本"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.regCapital || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("实缴资本"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.actualCapital || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("成立日期"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm.info.estiblishTime
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.info.estiblishTime.slice(0, 10))
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("核准日期"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm.info.approvedTime
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.info.approvedTime.slice(0, 10))
                              ),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("统一社会信用代码"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.creditCode || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("组织机构代码"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.orgNumber || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("纳税人识别号"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.taxNumber || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("工商注册号"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.regNumber || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("企业类型"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.companyOrgType || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("营业期限"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm.info.estiblishTime
                          ? _c("span", { staticClass: "mr-5" }, [
                              _vm._v(
                                _vm._s(_vm.info.estiblishTime.slice(0, 10)) +
                                  " 至 "
                              ),
                            ])
                          : _vm._e(),
                        _vm.info.toTime
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.info.toTime.slice(0, 10))),
                            ])
                          : _c("span", [_vm._v("无固定期限")]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("登记机关"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.regInstitute || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("人员规模"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.staffNumRange || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("曾用名")]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.historyNames || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("英文名")]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.property3 || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [_vm._v("简称")]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.alias || "--")),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("参保人数"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.socialStaffNum || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("所属地区"),
                      ]),
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("所属行业"),
                      ]),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _vm._v(_vm._s(_vm.info.industry || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("企业地址"),
                      ]),
                      _c("el-col", { attrs: { span: 19 } }, [
                        _vm._v(_vm._s(_vm.info.regLocation || "--")),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 5 } }, [
                        _vm._v("经营范围"),
                      ]),
                      _c("el-col", { attrs: { span: 19 } }, [
                        _vm._v(_vm._s(_vm.info.businessScope || "--")),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }